import { useEffect } from "react";
import { assets } from "../content/assets";

const siteUrl = "https://antonrost.de";

function setMeta(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
}

function setLink(rel, href, extra = {}) {
  const selector = extra.hreflang ? `link[rel="${rel}"][hreflang="${extra.hreflang}"]` : `link[rel="${rel}"]:not([hreflang])`;
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
  Object.entries(extra).forEach(([key, value]) => element.setAttribute(key, value));
}

export default function Seo({ locale, metadata, path, type = "website", schema = [], image = assets.qa.monitoringHealth, imageAlt }) {
  useEffect(() => {
    const canonicalPath = `/${locale}${path === "/" ? "/" : path}`;
    const canonical = `${siteUrl}${canonicalPath}`;
    document.documentElement.lang = locale;
    document.title = metadata.title;
    setMeta('meta[name="description"]', { name: "description", content: metadata.description });
    setMeta('meta[property="og:title"]', { property: "og:title", content: metadata.title });
    setMeta('meta[property="og:description"]', { property: "og:description", content: metadata.description });
    setMeta('meta[property="og:url"]', { property: "og:url", content: canonical });
    setMeta('meta[property="og:type"]', { property: "og:type", content: type });
    setMeta('meta[property="og:site_name"]', { property: "og:site_name", content: "Anton Rost QA Engineering Portfolio" });
    setMeta('meta[property="og:locale"]', { property: "og:locale", content: locale === "de" ? "de_DE" : "en_GB" });
    setMeta('meta[property="og:image"]', { property: "og:image", content: image.startsWith("http") ? image : `${siteUrl}${image}` });
    setMeta('meta[property="og:image:alt"]', { property: "og:image:alt", content: imageAlt || metadata.title });
    setMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    setMeta('meta[name="twitter:title"]', { name: "twitter:title", content: metadata.title });
    setMeta('meta[name="twitter:description"]', { name: "twitter:description", content: metadata.description });
    setMeta('meta[name="twitter:image"]', { name: "twitter:image", content: image.startsWith("http") ? image : `${siteUrl}${image}` });
    setMeta('meta[name="twitter:image:alt"]', { name: "twitter:image:alt", content: imageAlt || metadata.title });
    setLink("canonical", canonical);
    ["de", "en"].forEach(language => setLink("alternate", `${siteUrl}/${language}${path === "/" ? "/" : path}`, { hreflang: language }));
    setLink("alternate", `${siteUrl}/de${path === "/" ? "/" : path}`, { hreflang: "x-default" });
    let script = document.head.querySelector("script[data-portfolio-schema]");
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.portfolioSchema = "true";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);
  }, [locale, metadata, path, type, schema, image, imageAlt]);
  return null;
}
